import React from 'react';
import { Panel } from 'pages/user/components';
import { OutlineErrorIcon } from 'common/icons';
import { Button } from 'common/button';
import { useUpdateSignInState } from 'state/sign-in';

import styles from './forbidden-message.module.scss';

export const ForbiddenMessage = () => {
  const { backToSignIn } = useUpdateSignInState();

  return (
    <Panel className={styles.container}>
      <OutlineErrorIcon size={80} />
      <h2>Acceso denegado</h2>
      <span>Usted no tiene acceso a la plataforma.</span>
      <span>
        Si es el propietario del vehículo contacte con el administrador para que le sean otorgados los permisos.
      </span>
      <a href="mailto:soporte-idauto@dox.cl">soporte-idauto@dox.cl</a>

      <Button label="Aceptar" onClick={backToSignIn} />
    </Panel>
  );
};
